// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".full-user-info[data-v-df04da06]{display:flex;flex-flow:column}.full-user-info>*[data-v-df04da06]{white-space:nowrap;font-size:1.75rem}.full-user-info[data-v-df04da06]>:not(.full-user-info__email){text-transform:capitalize}", ""]);
// Exports
module.exports = exports;
